export const load = () => ({
	title: 'Interior Storm Windows | Standard Grade',
	showTitle: true,
});
